import React from 'react';
import chroma from 'chroma-js';

const Antenna = ({ height = 48, width = 48, color = '#494949', waveColor = '#00ceb8' }) => {
  const lightWaveColor = chroma(waveColor).brighten(1).desaturate(1);
  return (
    <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <title>antenna</title>
      <g>
        <path d="M38.85,34.85a1,1,0,0,1-.707-1.707,20,20,0,0,0,0-28.286,1,1,0,0,1,1.414-1.414,22,22,0,0,1,0,31.114A1,1,0,0,1,38.85,34.85Z" fill={waveColor} />
        <path d="M9.15,34.85a1,1,0,0,1-.707-.293,22,22,0,0,1,0-31.114A1,1,0,0,1,9.857,4.857a20,20,0,0,0,0,28.286A1,1,0,0,1,9.15,34.85Z" fill={waveColor} />
        <path d="M34.606,30.606A1,1,0,0,1,33.9,28.9a14,14,0,0,0,0-19.8,1,1,0,1,1,1.414-1.414,16,16,0,0,1,0,22.626A.993.993,0,0,1,34.606,30.606Z" fill={lightWaveColor} />
        <path d="M13.394,30.606a.993.993,0,0,1-.707-.293,16,16,0,0,1,0-22.626A1,1,0,1,1,14.1,9.1a14,14,0,0,0,0,19.8,1,1,0,0,1-.707,1.707Z" fill={lightWaveColor} />
        <path d="M32,44H25V22.858a4,4,0,1,0-2,0V44H16a1,1,0,0,0,0,2H32a1,1,0,0,0,0-2Z" fill={color} />
        <path d="M17.636,26.364a.993.993,0,0,1-.707-.293,10,10,0,0,1,0-14.142,1,1,0,1,1,1.414,1.414,8,8,0,0,0,0,11.314,1,1,0,0,1-.707,1.707Z" fill={waveColor} />
        <path d="M30.364,26.364a1,1,0,0,1-.707-1.707,8,8,0,0,0,0-11.314,1,1,0,1,1,1.414-1.414,10,10,0,0,1,0,14.142A.993.993,0,0,1,30.364,26.364Z" fill={waveColor} />
      </g>
    </svg>
  );
};

export default Antenna;
